import React from "react";
import OperatorHelpNotes from "../../../OrderDetails/OperatorHelpNotes";
import BPSlotAvailabilityControl from "../../BPSlotAvailability/BPSlotAvailability";
import COMRADSlotAvailabilityControl from "../../COMRADSlotAvailability/COMRADSlotAvailability";
import styles from "./SlotSelectionControl.module.css";
const SlotSelectionControl = ({slotSelectionHandler, conversationID,disableSlotSelectionControl,conversationWorkflowType,center_id,dataFromApiRequestedCallback }) => {
  return (
    <div className={styles.container}>
     
      <div className={styles.slots_container}>
        {conversationWorkflowType==="IMAGING_APPT" && 
        <COMRADSlotAvailabilityControl
           slotSelectionHandler={slotSelectionHandler}
           disableSlotSelectionControl={disableSlotSelectionControl}
           conversationID={conversationID}
           center_id={center_id}
           dataFromApiRequestedCallback={dataFromApiRequestedCallback}
        />}
        {conversationWorkflowType==="GP_APPT" && <BPSlotAvailabilityControl
           slotSelectionHandler={slotSelectionHandler}
           disableSlotSelectionControl={disableSlotSelectionControl}
           conversationID={conversationID}
        />}
      </div>
    </div>
  );
};

export default SlotSelectionControl;
